import { render } from "./SpendingDonutChart.vue?vue&type=template&id=6dd402dc&scoped=true"
import script from "./SpendingDonutChart.vue?vue&type=script&lang=js"
export * from "./SpendingDonutChart.vue?vue&type=script&lang=js"

import "./SpendingDonutChart.vue?vue&type=style&index=0&id=6dd402dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd402dc"]])

export default __exports__